import { MediaEntity, RawMedia } from './Types';
import { BaseModel } from '../BaseModel/BaseModel';

export class MediaModel extends BaseModel<RawMedia, MediaEntity> implements MediaEntity {
    createdAt: string = new Date().toISOString();
    deletedAt: string | null = null;
    filename: string = '';
    galleryId: number = 0;
    id: number = 0;
    mimeType: string = '';
    size: number = 0;
    updatedAt: string = new Date().toISOString();
    url: string = '';

    constructor(data?: RawMedia) {
        super();
        if (data) {
            this.initialize(data);
        }
    }

    initialize(data: RawMedia) {
        this.createdAt = data.created_at;
        this.deletedAt = data.deleted_at;
        this.filename = data.filename;
        this.galleryId = data.gallery_id;
        this.id = data.id;
        this.mimeType = data.mime_type;
        this.size = data.size;
        this.updatedAt = data.updated_at;
        this.url = data.url;
    }

    parse(): RawMedia {
        return {
            created_at: this.createdAt,
            deleted_at: this.deletedAt,
            filename: this.filename,
            gallery_id: this.galleryId,
            id: this.id,
            mime_type: this.mimeType,
            size: this.size,
            updated_at: this.updatedAt,
            url: this.url,
        };
    }
}